import styled from 'styled-components'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    gap: 16px;
    padding: 16px;
  }
`

export const Title = styled.h1`
  color: var(--foreground-neutral, #14171f);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
`

export const FieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`

export const Field = styled.div``

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  margin-top: 16px;
`

export const SubmitButton = styled.button`
  width: 328px;
  margin-top: 16px;

  border: none;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 36px;
  padding: 8px 12px;
  box-sizing: border-box;

  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    var(--Foreground-Secondary, #2fb609);

  background-blend-mode: soft-light, normal;

  /* Raised */
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1);

  color: var(--On-background-Primary, #fff);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  cursor: pointer;
`
